import {
  AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay,
  Button, Flex, Text, useDisclosure,
} from "@chakra-ui/react";
import { ArrowClockwise } from "@phosphor-icons/react";
import { useRef, useState } from "react";
import FileListWithBrowseOrUpload from "../../components/FileListWithBrowseOrUpload";
import RichTextEditor from "../../IssbDataInput/components/RichTextEditor/RichTextEditor";
import TargetsTable from "./TargetsTable";

const TargetsLayout = ({
  questionData,
  canSave,
  setCurrentAnswer,
  targets,
  onTargetsChange,
  fileInfoList,
  onFileInfoListChange,
  fileFolderForRound,
  tags,
  onImportTargets,
  hasPreviousYear,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();
  const [importing, setImporting] = useState(false);

  const doImport = async () => {
    setImporting(true);
    const imported = await onImportTargets();
    if (imported?.length > 0) {
      onTargetsChange(imported);
    }
    setImporting(false);
    onClose();
  };

  const handleImportClick = () => {
    if (targets.length > 0) {
      onOpen();
    } else {
      doImport();
    }
  };

  return (
    <Flex direction="column" gap={4}>
      {canSave && hasPreviousYear && (
        <Flex justify="flex-end">
          <Button
            leftIcon={<ArrowClockwise size={16} />}
            variant="outline"
            size="sm"
            onClick={handleImportClick}
            isLoading={importing}
          >
            Import from previous year
          </Button>
        </Flex>
      )}

      <TargetsTable targets={targets} onChange={onTargetsChange} readOnly={!canSave} />

      <Text fontSize="sm" fontWeight="600" color="gray.600">Additional Information</Text>
      <RichTextEditor
        content={questionData.answer || ""}
        onChange={(html) => setCurrentAnswer(html)}
        isDisabled={!canSave}
      />

      <FileListWithBrowseOrUpload
        fileLabel="reference file"
        readOnly={!canSave}
        onFileInfoListChange={onFileInfoListChange}
        fileInfoList={fileInfoList}
        tags={tags}
        folder={fileFolderForRound}
      />

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Import targets from previous year?
            </AlertDialogHeader>
            <AlertDialogBody>
              You have already added targets. Importing will replace your current targets with those from the previous year.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={doImport} isLoading={importing} ml={3}>
                Replace targets
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Flex>
  );
};

export default TargetsLayout;
